export default {
  namespaced: true,
  state: {
    title: "Finalizar",
    createPacket: true,
  },
};
